export { default as registerServiceworker } from './registerServiceworker';
